import { useRouteLoaderData } from "react-router";
import type { RootLoaderData } from "@/loaders/root-loader";

/**
 * Root loader のデータを取得するカスタムフック
 */
export function useRootLoader(): RootLoaderData {
  const data = useRouteLoaderData<RootLoaderData>("root");

  if (!data) {
    throw new Error(
      "useRootLoader must be used within routes that have root loader",
    );
  }

  return data;
}
